import React from 'react';

const News: React.FC = () => {
  const articles = [
    {
      id: 1,
      title: "Cách tính khối gỗ tròn chính xác",
      excerpt: "Hướng dẫn chi tiết cách tính khối gỗ tròn theo công thức chuẩn quốc tế và các lưu ý quan trọng khi đo đạc.",
      content: `Gỗ tròn (tiếng Anh là "Log") là loại gỗ có hình trụ, thon dài đã loại bỏ các cành, được khai thác từ các cây gỗ đứng, thường ở dạng tự nhiên hoặc đã được cắt thành từng phần ngắn, phần cắt ra gọi là khúc gỗ.

Gỗ tròn là loại nguyên liệu đầu tiên trong chuỗi cung ứng nguyên liệu gỗ tự nhiên. Từ gỗ tròn mới xẻ ra được gỗ phách (gỗ tấm), sau đó ra phôi nguyên liệu theo quy cách và cuối cùng mới hình thành nguyên liệu chi tiết tinh cho sản phẩm.

Hiện nay, trên thị trường có nhiều cách tính khối gỗ tròn khác nhau, được áp dụng tùy vào từng quốc gia, loại gỗ, kích thước gỗ… Thế nhưng, công thức tính cơ bản, đơn giản, dễ áp dụng nhất là tính khối gỗ theo như công thức tính thể tích của hình trụ:

V = L x S

Trong đó:
- V chính là thể tích của cây gỗ tròn cần tính, trong thuật ngữ ngành gỗ hay gọi là khối lượng gỗ, tính theo m³
- L là chiều dài của cây gỗ, khúc gỗ
- S là diện tích mặt cắt ở đầu của tấm gỗ, thế nhưng vì hai đầu của cây gỗ tròn không bằng nhau nên sẽ xác định S bằng cách lấy trung bình cộng của diện tích mặt cắt tròn ở hai đầu cây gỗ. Cụ thể, S = (S1+S2)/2; trong đó, S1 và S2 lần lượt là diện tích tiết diện của 2 đầu khúc gỗ tròn, khi đo đường kính khúc gỗ thì nên đo 2 đường kính vuông góc nhau, rồi chia 2 lấy trung bình sẽ tăng độ chính xác.`,
      date: "2024-01-15",
      category: "Kiến thức"
    },
    {
      id: 2,
      title: "Kiến thức cơ bản về gỗ thông",
      excerpt: "Tìm hiểu về đặc điểm, ưu điểm và ứng dụng của gỗ thông trong sản xuất và xây dựng.",
      content: `Gỗ Thông xẻ nhập khẩu từ Châu Âu mang lại sự mềm mại, bền bỉ với màu sắc tự nhiên, giúp doanh nghiệp sản xuất dễ dàng gia công và tăng giá trị thẩm mỹ cho sản phẩm cuối cùng.

Thông tin cơ bản:
- Tên khoa học: Pinus palustris
- Xuất xứ: Mỹ, Canada, Châu Âu
- Đặc điểm: Màu sắc tự nhiên, vân gỗ đẹp mắt

Ưu điểm của gỗ thông xẻ:
- Gỗ thông xẻ mềm nhưng vẫn chắc chắn và dẻo dai, khả năng kháng khuẩn và chống ẩm tốt
- Màu gỗ thông sáng, vân gỗ đẹp mắt rất thích hợp làm đồ nội thất hay trang trí để tăng tính thẩm mỹ cho ngôi nhà
- Tính đàn hồi của gỗ thông xẻ cao nên ít bị cong vênh
- Khả năng bám ốc vít, đinh tốt, bề mặt gỗ bám sơn tốt, dễ đánh bóng, nhuộm màu để có thành phẩm bền đẹp
- Chất gỗ nhẹ nên rất thuận tiện để di chuyển hoặc chế biến

Giá gỗ thông xẻ hiện nay dao động từ 6.000.000-10.000.000 VNĐ/m³ tùy thuộc vào quy cách, chất lượng, thời giá và số lượng đơn hàng cụ thể.`,
      date: "2024-01-10",
      category: "Sản phẩm"
    },
    {
      id: 3,
      title: "Phân loại gỗ theo tiêu chuẩn của Mỹ",
      excerpt: "Tìm hiểu về hệ thống phân hạng gỗ cứng xẻ Hoa Kỳ theo tiêu chuẩn NHLA.",
      content: `Gỗ cứng xẻ Hoa Kỳ được phân hạng theo những tiêu chuẩn do Hiệp hội Gỗ cứng xẻ Hoa Kỳ (NHLA) đề ra. Những tiêu chuẩn của NHLA được thiết lập với xu hướng thương mại đồ gỗ, quy định một tỷ lệ phần trăm nhất định về mặt gỗ sạch, không khiếm khuyết cho từng hạng gỗ.

Cách phân hạng của NHLA dựa trên tỷ lệ gỗ sạch trên một thanh gỗ. Cách đo đạc tỷ lệ này gọi là các đoạn gỗ sạch. Ngoại trừ phân hạng FAS, phân hạng của một thanh gỗ được xác định từ tỷ lệ của những đoạn gỗ sạch này và không xét đến các khiếm khuyết bên ngoài vùng gỗ sạch.

Các phân hạng chính bao gồm:
- FAS (First and Seconds): Chất lượng cao nhất
- Select: Chất lượng tốt, ít khuyết tật
- No. 1 Common: Chất lượng trung bình
- No. 2 Common: Chất lượng thấp hơn

Việc hiểu rõ hệ thống phân hạng này giúp khách hàng lựa chọn được loại gỗ phù hợp với nhu cầu và ngân sách của mình.`,
      date: "2024-01-05",
      category: "Tiêu chuẩn"
    }
  ];

  return (
    <div className="news">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Tin tức & Kiến thức</h1>
          <p>Những thông tin hữu ích về gỗ và ngành công nghiệp gỗ</p>
        </div>
      </section>

      {/* Articles List */}
      <section className="section">
        <div className="container">
          <div className="grid grid-2">
            {articles.map((article) => (
              <article key={article.id} className="card">
                <div style={{ marginBottom: '1rem' }}>
                  <span style={{ 
                    backgroundColor: 'var(--primary-color)', 
                    color: 'white', 
                    padding: '0.25rem 0.75rem', 
                    borderRadius: '15px',
                    fontSize: '0.8rem',
                    fontWeight: '500'
                  }}>
                    {article.category}
                  </span>
                  <span style={{ 
                    color: 'var(--text-light)', 
                    fontSize: '0.9rem',
                    marginLeft: '1rem'
                  }}>
                    {new Date(article.date).toLocaleDateString('vi-VN')}
                  </span>
                </div>
                
                <h3 style={{ marginBottom: '1rem' }}>{article.title}</h3>
                <p style={{ marginBottom: '1.5rem' }}>{article.excerpt}</p>
                
                <details id={`details-${article.id}`} style={{ marginBottom: '1rem' }}>
                  <summary style={{ 
                    cursor: 'pointer', 
                    fontWeight: '500',
                    color: 'var(--primary-color)',
                    marginBottom: '1rem'
                  }}>
                    Đọc thêm...
                  </summary>
                  <div style={{ 
                    padding: '1rem', 
                    backgroundColor: 'var(--bg-light)', 
                    borderRadius: '5px',
                    lineHeight: '1.6'
                  }}>
                    {article.content.split('\n').map((paragraph, index) => (
                      <p key={index} style={{ marginBottom: '1rem' }}>
                        {paragraph}
                      </p>
                    ))}
                  </div>
                </details>
                
                <div style={{ 
                  borderTop: '1px solid var(--border-color)', 
                  paddingTop: '1rem',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <span style={{ fontSize: '0.9rem', color: 'var(--text-light)' }}>
                    Đức Phát Đạt
                  </span>
                  <button 
                    className="btn btn-primary"
                    onClick={() => {
                      const details = document.getElementById(`details-${article.id}`);
                      if (details) {
                        (details as HTMLDetailsElement).open = !(details as HTMLDetailsElement).open;
                      }
                    }}
                  >
                    Xem chi tiết
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Knowledge Base */}
      <section className="section bg-light">
        <div className="container">
          <div className="section-title">
            <h2>Cẩm nang kiến thức</h2>
            <p>Những kiến thức cơ bản về gỗ và cách sử dụng</p>
          </div>
          
          <div className="grid grid-3">
            <div className="card text-center">
              <div style={{ fontSize: '3rem', color: 'var(--accent-color)', marginBottom: '1rem' }}>📏</div>
              <h4>Cách đo đạc gỗ</h4>
              <p>Hướng dẫn chi tiết cách đo đạc và tính toán khối lượng gỗ chính xác.</p>
            </div>
            
            <div className="card text-center">
              <div style={{ fontSize: '3rem', color: 'var(--accent-color)', marginBottom: '1rem' }}>🌳</div>
              <h4>Phân loại gỗ</h4>
              <p>Tìm hiểu về các loại gỗ khác nhau và đặc điểm của từng loại.</p>
            </div>
            
            <div className="card text-center">
              <div style={{ fontSize: '3rem', color: 'var(--accent-color)', marginBottom: '1rem' }}>🔧</div>
              <h4>Kỹ thuật xử lý</h4>
              <p>Các phương pháp xử lý và bảo quản gỗ để đảm bảo chất lượng.</p>
            </div>
            
            <div className="card text-center">
              <div style={{ fontSize: '3rem', color: 'var(--accent-color)', marginBottom: '1rem' }}>🏗️</div>
              <h4>Ứng dụng xây dựng</h4>
              <p>Cách sử dụng gỗ hiệu quả trong các dự án xây dựng và nội thất.</p>
            </div>
            
            <div className="card text-center">
              <div style={{ fontSize: '3rem', color: 'var(--accent-color)', marginBottom: '1rem' }}>🌱</div>
              <h4>Bảo vệ môi trường</h4>
              <p>Tầm quan trọng của việc sử dụng gỗ hợp pháp và bền vững.</p>
            </div>
            
            <div className="card text-center">
              <div style={{ fontSize: '3rem', color: 'var(--accent-color)', marginBottom: '1rem' }}>💼</div>
              <h4>Thị trường gỗ</h4>
              <p>Thông tin về xu hướng thị trường gỗ và giá cả hiện tại.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact for More Info */}
      <section className="section">
        <div className="container text-center">
          <h2>Cần thêm thông tin?</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
            Chúng tôi sẵn sàng tư vấn và cung cấp thêm thông tin chi tiết về gỗ và dịch vụ
          </p>
          <div style={{ marginBottom: '2rem' }}>
            <p><strong>Hotline tư vấn:</strong> 0915 444 447 (anh Kiên) | 0906 838 171 (cô Nhung)</p>
            <p><strong>📧 Email:</strong> ducphatdatco@gmail.com</p>
          </div>
          <a href="/contact" className="btn btn-primary">
            Liên hệ tư vấn
          </a>
        </div>
      </section>
    </div>
  );
};

export default News;

